export const createArrayByLength = (length: number) => Array.from({ length }, (_, i) => i + 1)
